import {computed, ref} from 'vue'
import {Position} from '@vueuse/core'
import {clamp} from 'lodash'
import {attachmentPresetSizes, PresetSize, useUserPrefs} from '@/user-prefs/userPrefs.service'

const {isHoverToOpenDocumentPreviewModal, documentPreviewModalPosition, documentPreviewModalSize} = useUserPrefs()

const selectedDocumentMetaUuid = ref<string>()

const useDocumentPreviewModalService = () => {
    const handleOpenDocumentPreviewModal = (uuid: string) => {
        selectedDocumentMetaUuid.value = uuid
        ensureSafePosition(documentPreviewModalPosition.value)
    }

    const onClickDocumentLink = (uuid: string) => {
        handleOpenDocumentPreviewModal(uuid)
    }

    const onHoverDocumentLink = (uuid: string) => {
        if (isHoverToOpenDocumentPreviewModal.value) {
            handleOpenDocumentPreviewModal(uuid)
        }
    }

    const onClickCloseDocumentPreviewModal = () => {
        selectedDocumentMetaUuid.value = undefined
    }

    const onChangeDocumentPreviewModalSize = (size: PresetSize) => {
        const preset = attachmentPresetSizes.find(p => p.name === size.name)
        if (!preset) {
            console.error('Unable to find preset size with key', size)
            return
        }
        documentPreviewModalSize.value = preset
    }

    const ensureSafePosition = (position: Position) => {
        // Use Lodash clamp to make sure height and width is within bounds. Window width must be calculated using ~ A4 aspect ratio (1/1.46)
        const maxX = window.innerWidth - documentPreviewModalSize.value.height / 1.46
        const maxY = window.innerHeight - documentPreviewModalSize.value.height
        documentPreviewModalPosition.value = {
            x: clamp(position.x, 0, maxX),
            y: clamp(position.y, 0, maxY)
        }
        position.x = documentPreviewModalPosition.value.x
        position.y = documentPreviewModalPosition.value.y
    }

    const isDocumentPreviewModalOpen = computed(() => Boolean(selectedDocumentMetaUuid.value))

    return {
        isDocumentPreviewModalOpen,
        selectedDocumentMetaUuid,
        documentPreviewModalSize,
        onChangeDocumentPreviewModalSize,
        isHoverToOpenDocumentPreviewModal,
        documentPreviewModalPosition,
        ensureSafePosition,
        onClickDocumentLink,
        onHoverDocumentLink,
        onClickCloseDocumentPreviewModal
    }
}

export {useDocumentPreviewModalService}